"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mobileVersion = exports.hasMobileUserAgent = void 0;
const hasMobileUserAgent = (navigator = window.navigator || { userAgent: '' }) => /CarvanaNativeWebView/gi.test(navigator.userAgent);
exports.hasMobileUserAgent = hasMobileUserAgent;
const iPhoneRegex = new RegExp('CarvanaNativeWebView/(?<AppVersion>\\S+) \\((?<DeviceName>[^;]+); CPU iPhone OS (?<OsVersion>\\S+)');
const androidRegex = new RegExp('CarvanaNativeWebView/(?<AppVersion>\\S+) \\(Linux; Android (?<OsVersion>[^;]+); (?<DeviceName>[^;]+); wv');
const mobileVersion = ({ userAgent } = window.navigator || { userAgent: '' }) => {
    var _a, _b, _c;
    if (!/CarvanaNativeWebView/gi.test(userAgent)) {
        return null;
    }
    const iPhone = /iPhone/.test(userAgent);
    const regex = iPhone ? iPhoneRegex : androidRegex;
    const matches = regex.exec(userAgent);
    return {
        appVersion: ((_a = matches === null || matches === void 0 ? void 0 : matches.groups) === null || _a === void 0 ? void 0 : _a.AppVersion) || 'Unknown',
        osVersion: ((_b = matches === null || matches === void 0 ? void 0 : matches.groups) === null || _b === void 0 ? void 0 : _b.OsVersion) || 'Unknown',
        deviceName: ((_c = matches === null || matches === void 0 ? void 0 : matches.groups) === null || _c === void 0 ? void 0 : _c.DeviceName) || 'Unknown',
        appType: iPhone ? 'iPhone' : 'Android',
        matched: matches != null,
        userAgent
    };
};
exports.mobileVersion = mobileVersion;
